module.exports = __webpack_public_path__ + "img/douyin-code.a3452793.png";